<template>
    <div class="main-content" id="panel">
        <div class="header bg-primary pb-6">
            <div class="container-fluid">
            <div class="header-body">
                <div class="row align-items-center py-4">
                <div class="col-lg-6 col-7">
                    <h2>Settings</h2>
                </div>
                </div>
                
            </div>
            </div>
        </div>
        <div class="container-fluid mt--6" >
            <div class="row justify-content-md-center upload">
                <div class="col-xl-5">
                    <div class="card p-3">
                        <div class="card-header bg-transparent">
                            <div class="row align-items-center">
                                <div class="col">
                                    <h5 class="mb-3">General Settings</h5>
                                </div>
                            </div>
                        </div>
                        <form class="mt-4">
                            <div class="form-row settings">
                                <div class="form-group col-md-8">
                                    <label for="inputEmail4">Settlement Date Calculated :  <span v-if="calculatedDate" class="calcDate text-primary"><i class="far fa-calendar-alt"></i> {{moment(calculatedDate).format("MM/DD/yyyy")}}</span></label>
                                    <datepicker 
                                        v-model="settilementDate" 
                                        placeholder="mm/dd/yyyy" 
                                        typeable 
                                        name="callDate" 
                                        format="MM/dd/yyyy" 
                                        :clear-button="true" 
                                        :calendar-button="true" 
                                        :disabledDates="disabledDates"
                                        calendar-button-icon="fas fa-calendar-alt datepicker_icon"></datepicker>
                                    <small class="text-danger">Auto calculated date. You can change the date.</small>
                                </div>
                                <!-- <div class="form-group col-md-6 d-flex align-items-center">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" id="gridCheck">
                                        <label class="form-check-label" for="gridCheck"> Overide</label>
                                    </div>
                                </div> -->
                                <div class="form-group col-md-4">
                                    <label for="inputEmail4">Merge Factor</label>
                                    <input type="number" v-model="settings.mergeFactor" class="form-control" id="inputEmail4"  placeholder="0">
                                </div>
                                <div class="form-group col-md-4">
                                    <label for="inputEmail4">Default Minimum</label>
                                    <input type="number" v-model="settings.minParValue" class="form-control" id="inputEmail4" placeholder="0" step="1" min="0"  >
                                </div>
                                <div class="form-group col-md-4">
                                    <label for="inputEmail4">Default Increment</label>
                                    <input type="number" v-model="settings.minQuantityLeft" class="form-control" id="inputEmail4"  placeholder="0">
                                </div>
                                <!-- <div class="form-group col-md-4">
                                    <label for="inputEmail4">Max Cusips</label>
                                    <input type="number" v-model="settings.maxCusips"  class="form-control" id="inputEmail4"  placeholder="0">
                                </div> -->
                                <!-- <div class="form-group col-md-4">
                                    <label for="inputEmail4">Offer Validity</label>
                                    <select class="form-control number" id="exampleFormControlSelect1"  v-model.number="settings.bidValidity">
                                        <option value="1">1</option>
                                        <option value="2">2</option>
                                        <option value="3">3</option>
                                    </select>
                                    
                                </div> -->
                                 <!-- <div class="form-group col-md-4">
                                    <label for="inputEmail4">Max Capital</label>
                                    <input type="number" v-model="settings.maxCapital"  class="form-control" id="inputEmail4"  placeholder="0">
                                </div>
                                 <div class="form-group col-md-4">
                                    <label for="inputEmail4">Max Par Value</label>
                                    <input type="number" v-model="settings.maxParValue"  class="form-control" id="inputEmail4"  placeholder="0">
                                </div> -->
                                 <div class="form-group col-md-4">
                                    <label for="inputEmail4">TMC Account</label>
                                    <select class="form-control" v-model="settings.tmcAccountId" >
                                        <option value="">Choose A/C No</option>
                                        <option v-if="tmcAccountList.length == 0" >Loading...</option>
                                        <option
                                                v-for="tmc in tmcAccountList"
                                                :key="tmc.id"
                                                v-bind:value="tmc.id"
                                            >{{tmc.account}}</option>
                                    </select>
                                </div>
                                 <div class="form-group col-md-4">
                                    <label for="inputEmail4">BondPoint Account</label>
                                    <select class="form-control" v-model="settings.bpAccountId" >
                                        <option value="">Choose A/C No</option>
                                        <option v-if="bpAccountList.length == 0" >Loading...</option>
                                        <option
                                                v-for="bp in bpAccountList"
                                                :key="bp.id"
                                                v-bind:value="bp.id"

                                            >{{bp.account}}</option>
                                    </select>
                                </div>
                                 <div class="form-group col-md-4">
                                    <label for="inputEmail4">TradeWeb Account</label>
                                    <select class="form-control mb-2" v-model="settings.twAccountId" >
                                        <option value="">Choose A/C No</option>
                                        <option v-if="twAccountList.length == 0" >Loading...</option>
                                        <option
                                                v-for="tw in twAccountList"
                                                :key="tw.id"
                                                v-bind:value="tw.id"

                                            >{{tw.account}}</option>
                                    </select>
                                </div>
                                <div class="form-group col-md-4">
                                    <label for="inputEmail4">MarketAxess Account</label>
                                    <select class="form-control mb-2" v-model="settings.mktxAccountId" >
                                        <option value="">Choose A/C No</option>
                                        <option v-if="mktxAccountList.length == 0" >Loading...</option>
                                        <option
                                                v-for="mktx in mktxAccountList"
                                                :key="mktx.id"
                                                v-bind:value="mktx.id"

                                            >{{mktx.account}}</option>
                                    </select>
                                </div>
                                <div class="row col-md-12 align-items-center">
                                    <div class="col">
                                        <h5 class="mb-3">User Settings</h5>
                                    </div>
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="inputEmail4">Overdue Purchase Highlight
                                        <span class="hint" data-toggle="tooltip" data-placement="right"  title="The bought date will be highlighted if it was purchased prior to the specified number of days.">
                                        <i class="fa fa-info-circle" style="color: #ffa300"></i> </span>
                                    </label>
                                    <input type="number" v-model="overduePurchaseHighlight"  class="form-control" id="inputEmail4"  placeholder="0">
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="inputEmail4">Add To Hib - Broker Account</label>
                                    <select class="form-control mb-2" v-model="brockerAccount" >
                                        <option value="">Choose A/C No</option>
                                        <option v-if="brockerAccountList.length == 0" >Loading...</option>
                                        <option
                                                v-for="account in brockerAccountList"
                                                :key="account.accountMappingId"
                                                v-bind:value="account.accountMappingId"

                                            >{{account.account}}</option>
                                    </select>
                                </div>
                                <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>

                                <div class="form-group col-md-12 text-center">
                                    <!-- <button type="button" class="btn btn-light">RESET</button> -->
                                    <button :disabled="!settings.twAccountId || !settings.bpAccountId || !settings.tmcAccountId || !settings.mktxAccountId" @click="setSettings()" type="button" class="btn btn-success">SAVE</button>
                                </div>

                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>    
</template>
<script>
import authService from "@/authService";
import config from "@/config";
import Datepicker from 'vuejs-datepicker';

export default {
  name: "imsComponent",
  components : {
      Datepicker
  },
  data() {
    return {
        settings : {},
        settilementDate :null,
        loading : false,
        tmcAccountList : [],
        bpAccountList : [],
        twAccountList : [],
        mktxAccountList : [],
        disabledDates: {
          to: this.getYestedayDate()
        },
        calculatedDate : null,
        invHoldingFrom : null,
        invHoldingTo : null,
        overduePurchaseHighlight : 0,
        brockerAccountList : [],
        brockerAccount : null
    };
  },
  methods: { 
    getBrockerAccountList(){
        const auth = {
            headers: {'org-token' : authService.getOrgToken() }
        };
        this.$http
            .get(
            config.baseUrlBidSide +
                "/account/customer-account",
                auth
            )
            .then(result => {
                this.brockerAccountList = result.data;
                // this.getUserSetting();
            })
            .catch(e => {
                console.log(e);
            });
    },
   filterKey(e){
      const key = e.key;
      // If is '.' key, stop it
      if (key === '.')
        return e.preventDefault();
      // OPTIONAL
      // If is 'e' key, stop it
      if (key === 'e')
        return e.preventDefault();
    },
    getUserSetting(){
        this.loading = true;
        const auth = {
            headers: {'org-token' : authService.getOrgToken() }
        };
        this.$http
            .get(
            config.baseUrlBidSide +
                "/tradebook/setting-list?cognitoSub="+authService.getUser().cognitoSub,
                auth
            )
            .then(result => {
                result.data.forEach(element => {
                    if(element.setting == "INVENTORY_HOLDING_OVERDUE_PUCHASE_DAYS"){
                        this.overduePurchaseHighlight = element.value
                    }
                    if(element.setting == "ADD_TO_HIB_BROKER_ACCOUNT"){
                        this.brockerAccount = element.value
                    }
                    
                });
                this.loading = false;
            })
            .catch(e => {
                console.log(e);
            });
    },
    saveUserSettings(){
        let dataToSend = [
                            {
                                "setting": "INVENTORY_HOLDING_OVERDUE_PUCHASE_DAYS",
                                "dataType": "STRING",
                                "value":  this.overduePurchaseHighlight,
                                "cognitoSub": authService.getUser().cognitoSub
                            },
                            {
                                "setting": "ADD_TO_HIB_BROKER_ACCOUNT",
                                "dataType": "NUMERIC",
                                "value":  this.brockerAccount,
                                // "cognitoSub": authService.getUser().cognitoSub
                            },
                           
                        ]
        const auth = {
            headers: {'org-token' : authService.getOrgToken() }
        };
        this.$http
            .post(
            config.baseUrlBidSide +
                "/tradebook/setting",dataToSend,
                auth
            )
            .then(() => {

            })
            .catch(e => {
                console.log(e);
            });

        if(this.isAutoBidder){
            this.setBlackBoxEcn()
        }
    },
    getSettings(){
        this.loading = true;
        const auth = {
            headers: { 'org-token' : authService.getOrgToken() }
        };
        this.$http
        .get(
           config.baseUrlBidSide +
            "/organization/bid-settings?type=OFFER",
            auth
        )
        .then(result => {
          this.settings = result.data;
          this.calculatedDate = this.settings.previousSettlementDate  ? this.settings.previousSettlementDate :  this.settings.settlementDate;
          this.settilementDate = this.settings.settlementDate;
          this.loading = false;

        })        
    },
    setSettings(){
        this.loading = true;
        let data = {...this.settings};
        delete data.settlementDate;
        //data.overrideSettlementDate = this.settilementDate ? this.settilementDate : "" ;
        data.overrideSettlementDate = this.settilementDate ? this.moment(this.settilementDate).format("MM/DD/YYYY")  : "" ;
         const auth = {
            headers: { 'org-token' : authService.getOrgToken() }
        };
        this.$http
        .put(
           config.baseUrlBidSide +
            "/organization/bid-settings",
            data,
            auth
        )
        .then(() => {
            this.saveUserSettings();
            this.$alert("Settings Updated","","success");
            this.loading = false;
        }).catch(() => this.loading = false)     

    },
    getAccountList(){
      this.loading = true;

      const auth = {
        headers: {'org-token' : authService.getOrgToken() }
      };
      this.$http
        .get(
          config.baseUrlBidSide + "/account/list?ecn=IBP,TMC,TWD,MKTX",
          auth
        )
        .then(response => {
            this.bpAccountList = response.data.filter((item) => {
                return item.ecn == 'IBP' && item.accountValue != 'SMU0000042'
            });
            this.tmcAccountList = response.data.filter((item) => {
                return item.ecn == 'TMC'
            });
            this.twAccountList = response.data.filter((item) => {
                return item.ecn == 'TWD'
            });
            this.mktxAccountList = response.data.filter((item) => {
                return item.ecn == 'MKTX'
            });
         this.getSettings()

        })
        .catch(e => {
          console.log(e);
          this.loading = false;
        });
    }
  },
  mounted() {
    this.getBrockerAccountList();
    this.getAccountList();
    this.getUserSetting();
    //this.getSettings()
  }
};
</script>